import EquativTable from './EquativTable'

export default EquativTable